import axios from 'axios';

const getVideoInfo = ({ queryKey: [site, id] }) =>
  axios
    .get(`https://${site}.com/api/v2/video/${id}.json`)
    .then((res) => res.data);

export default getVideoInfo;
